import axios from 'axios';

import Constants from './Constants';

const CrmService = () => {
  const CRM_URL = Constants.CRM.URL;

  const _headers = (accessToken) => ({
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  const getProfile = (accessToken) =>
    axios.get(`${CRM_URL}/user-profile`, _headers(accessToken));

  const saveProfile = (accessToken, profile) =>
    axios.put(`${CRM_URL}/user-profile`, profile, _headers(accessToken));

  const saveAdminUsers = (accessToken, admUsrsToSave) =>
    axios.put(
      `${CRM_URL}/update-status/bulk`,
      admUsrsToSave,
      _headers(accessToken)
    );

  const toggleUser = (
    accessToken,
    // eslint-disable-next-line
    user,
    EnabledInExtranet
  ) =>
    axios.put(
      `${CRM_URL}/update-status`,
      {
        // eslint-disable-next-line
        contactId: user.contactId,
        planId: user.planId,
        email: user.email,
        accessEnabled: EnabledInExtranet,
      },
      _headers(accessToken)
    );

  return {
    getProfile,
    saveProfile,
    toggleUser,
    saveAdminUsers,
  };
};

export default CrmService;
